import { useEffect } from "react";
import { X } from "lucide-react";
import "./DetailDrawer.css";

export default function DetailDrawer({
  isOpen,
  onClose,
  title,
  subtitle = "",
  children,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="admin-detail-drawer-overlay" onClick={onClose}>
      <aside
        className="admin-detail-drawer"
        onClick={(event) => event.stopPropagation()}
        aria-modal="true"
        role="dialog"
        aria-label={title}
      >
        <div className="admin-detail-drawer-header">
          <div className="admin-detail-drawer-heading">
            <h3>{title}</h3>
            {subtitle ? (
              <p>{subtitle}</p>
            ) : null}
          </div>
          <button
            type="button"
            className="admin-detail-drawer-close"
            onClick={onClose}
            aria-label="Close drawer"
          >
            <X size={20} />
          </button>
        </div>
        <div className="admin-detail-drawer-body">{children}</div>
      </aside>
    </div>
  );
}
